var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInquiry(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2076_9560)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 8,
    width: 90,
    height: 90,
    rx: 45,
    fill: "#DADADA",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4863 68.3955V70.1709H33.457V72.9307H31.2422V70.1709H24.8438V68.3955H39.4863ZM37.6055 61.1885V67.0771H26.6719V61.1885H37.6055ZM28.8691 62.9287V65.3369H35.4082V62.9287H28.8691ZM37.8691 74.4072V76.2002H26.5664V71.542H28.7988V74.4072H37.8691ZM45.6035 61.5576C48.1348 61.54 50.0332 63.1924 50.0332 65.4775C50.0332 67.7803 48.1348 69.415 45.6035 69.415C43.0723 69.415 41.1562 67.7803 41.1562 65.4775C41.1562 63.1924 43.0723 61.54 45.6035 61.5576ZM45.6035 63.4912C44.3379 63.4912 43.3711 64.2295 43.3887 65.4775C43.3711 66.7432 44.3379 67.4639 45.6035 67.4639C46.8691 67.4639 47.8359 66.7432 47.8535 65.4775C47.8359 64.2295 46.8867 63.4912 45.6035 63.4912ZM53.8652 60.4854V76.5166H51.6328V60.4854H53.8652ZM40.4883 71.4189C43.3359 71.4365 47.291 71.3838 50.7188 70.9092L50.8945 72.5264C47.3438 73.2119 43.5469 73.2471 40.752 73.2471L40.4883 71.4189ZM68.5957 60.4854V66.7432H70.9512V68.5889H68.5957V76.4814H66.3809V60.4854H68.5957ZM65.291 62.876V64.6689H55.8867V62.876H59.5078V60.7314H61.7578V62.876H65.291ZM60.6328 65.5654C62.9707 65.5654 64.7109 67.1475 64.7109 69.3799C64.7109 71.6123 62.9707 73.1943 60.6328 73.1943C58.2773 73.1943 56.5371 71.6123 56.5371 69.3799C56.5371 67.1475 58.2773 65.5654 60.6328 65.5654ZM60.6328 67.376C59.5078 67.3936 58.6816 68.1494 58.6816 69.3799C58.6816 70.6279 59.5078 71.3662 60.6328 71.3486C61.7578 71.3662 62.5664 70.6279 62.5664 69.3799C62.5664 68.1494 61.7578 67.3936 60.6328 67.376ZM84.9785 60.4854V76.4814H82.7109V60.4854H84.9785ZM80.1797 62.1553C80.1797 67.0068 78.4746 71.0322 72.7617 73.7393L71.584 71.9463C75.7148 69.9951 77.5342 67.4639 77.8945 63.9131H72.4453V62.1553H80.1797Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1382 50.626V50.6517",
    stroke: "white",
    strokeWidth: 5.13774,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1377 41.6351C54.0904 40.8012 54.3154 39.9744 54.7787 39.2795C55.242 38.5845 55.9186 38.0589 56.7066 37.7818C57.6722 37.4125 58.5389 36.8242 59.2384 36.0631C59.938 35.302 60.4513 34.3889 60.738 33.3957C61.0247 32.4025 61.0769 31.3563 60.8906 30.3394C60.7043 29.3226 60.2844 28.3629 59.6642 27.5359C59.0439 26.7089 58.2402 26.0371 57.3162 25.5735C56.3922 25.1099 55.3732 24.8672 54.3395 24.8643C53.3057 24.8614 52.2854 25.0985 51.3589 25.557C50.4323 26.0155 49.6248 26.6827 49 27.5063",
    stroke: "white",
    strokeWidth: 5.13774,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2076_9560",
    x: 0,
    y: 0,
    width: 110,
    height: 110,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2076_9560"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2076_9560",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInquiry);
export default __webpack_public_path__ + "static/media/inquiry.accd8dfeceda1e4e105048a75814c8a7.svg";
export { ForwardRef as ReactComponent };